import React from 'react'
import { Box, Text } from '@workwhile/ui'
import { VndlyIssuesFilterBar } from './VndlyIssuesFilterBar'
import { Header } from 'components/Header'
import { VndlyPositionIssues } from './VndlyPositionIssues/VndlyPositionIssues'
import { VndlyCandidateIssues } from './VndlyCandidateIssues/VndlyCandidateIssues'
import { VndlyWorkOrderIssues } from './VndlyWorkOrderIssues/VndlyWorkOrderIssues'

export const VndlyIssuesMain = () => {
  return (
    <>
      <Header title="VNDLY Issues" />
      <VndlyIssuesFilterBar />
      <Box margin={3}>
        <Text fontWeight="bold" mb={2}>
          Position Issues
        </Text>
        <VndlyPositionIssues />
      </Box>
      <Box margin={3}>
        <Text fontWeight="bold" mb={2}>
          Candidate Issues
        </Text>
        <VndlyCandidateIssues />
      </Box>
      <Box margin={3}>
        <Text fontWeight="bold" mb={2}>
          Work Order Issues
        </Text>
        <VndlyWorkOrderIssues />
      </Box>
    </>
  )
}
